// @flow

import React, { useRef, useEffect } from "react";
import "./styles.css";
import uuid from "uuid";
import withValidation from "../with-validation";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const excludedProps = ["id", "type", "onSearch", "value", "onChange", "children", "className", "errorMessage", "isError", "labelText"];

type PropsType = {
    id?: string,
    className?: string,
    disabled?: boolean,
    errorMessage?: string,
    isError?: boolean,
    onChange: any => any,
    labelText?: string,
    readOnly?: boolean,
    required?: boolean,
    style?: Object,
    onSearch: string => void,
    value: ?string
};

const filterProps = (_props: any): any => ({
    ...Object.keys(_props)
        .filter(key => excludedProps.indexOf(key) === -1)
        .reduce((obj, key) => ({ ...obj, [key]: _props[key] }), {})
});

const MyComponent = (props: PropsType) => {


    const {
        disabled = false,
        isError = false,
        required = false,
        errorMessage = "Error",
        readOnly = false,
        onSearch,
        id,
        labelText,
        className,
        onChange
    } = props;

    const elementProps = filterProps(props);
    const inputEl = useRef();
    const _id =
        id || uuid();

    return (
        <label
            className={ classNames("search-box",
                {
                    "is-required": required,
                    "is-error": isError,
                    "is-disabled": disabled,
                    "is-read-only": readOnly,
                    [className]: Boolean(className)
                }
            ) }
            htmlFor={ _id }
        >
            <input
                className={ "search-box--input" }
                { ...elementProps }
                type={ "text" }
                onChange={ onChange }
                ref={ inputEl }
                onKeyUp={ (e) => {
                    if (e.keyCode === 13) {
                        onSearch(inputEl.current.value);
                    }
                } }
            />
            <FontAwesomeIcon className={"search-box--icon"} icon={ faSearch } onClick={ () => onSearch(inputEl.current.value) }/>
        </label>
    );
};


export const SearchBox = withValidation(MyComponent);